import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="about-hero-content">
          <p className="about-tagline">About</p>
          <h1 className="about-title">Protecting What Matters Most</h1>
          <p className="about-subtitle">Building innovative technology to keep families safe</p>
        </div>
      </section>

      <section className="content-section">
        <div className="content-row">
          <div className="content-image">
            <img src="/Baby1.png" alt="Mission" />
          </div>
          <div className="content-text">
            <h2>Our Mission</h2>
            <p className="content-quote">
              "To safeguard children's lives by providing innovative, reliable technology that prevents vehicular hyperthermia and gives parents peace of mine."
            </p>
          </div>
        </div>
      </section>

      <section className="content-section alt">
        <div className="content-row reverse">
          <div className="content-image">
            <img src="/Baby2.png" alt="Vision" />
          </div>
          <div className="content-text">
            <h2>Our Vision</h2>
            <p className="content-quote">
              "To create a world where no child is lost to preventable vehicular hyperthermia, where technology serves as a guardian angel for families."
            </p>
          </div>
        </div>
      </section>

      <section className="values-section">
        <div className="values-container">
          <h2>Core Values</h2>
          <div className="values-layout">
            <div className="values-image">
              <img src="/Baby3.png" alt="Child Safety" />
            </div>
            <div className="values-grid">
              <div className="value-card">
                <h3>Child Safety First</h3>
                <p>Every decision prioritizes the protection of children</p>
              </div>
              <div className="value-card">
                <h3>Innovation & Reliability</h3>
                <p>Cutting-edge technology you can trust</p>
              </div>
              <div className="value-card">
                <h3>Peace of Mine</h3>
                <p>Empowering parents with confidence and security</p>
              </div>
              <div className="value-card">
                <h3>Intelligent Design</h3>
                <p>Simple, intuitive solutions for complex problems</p>
              </div>
              <div className="value-card">
                <h3>Prevention Over Response</h3>
                <p>Proactive protection before emergencies occur</p>
              </div>
              <div className="value-card">
                <h3>Trust & Transparency</h3>
                <p>Open, honest communication with our families</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-container">
          <h2>Join the Mission</h2>
          <p>Be the first to know when Miyel launches</p>
          <a href="/#signup" className="cta-button">Get Notified</a>
        </div>
      </section>
    </div>
  );
};

export default About;
